import axios from "axios";
import { getNodeServerUrl } from "../utils/getNodeUrl";

// Logs impersonation events (login/logout) to backend
export const createImpersonationLogApi = async (
  loggedInUser,
  impersonatedTo
) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const nodeBaseUrl = getNodeServerUrl();
  const options = {
    url: `${nodeBaseUrl}/impersonation-log`,
    method: "post",
    headers: headers,
    data: {
      logged_in_user: loggedInUser,
      impersonated_to: impersonatedTo,
    },
  };
  try {
    const response = await axios(options);
    return response;
  } catch (error) {
    console.log(error);
  }
};
